module.exports = __webpack_public_path__ + "img/sld_scb_4_t1_green.91408bf6.svg";